import { render, staticRenderFns } from "./PatientProfileCriteria.vue?vue&type=template&id=4d36c27f&"
import script from "./PatientProfileCriteria.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PatientProfileCriteria.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d36c27f')) {
      api.createRecord('4d36c27f', component.options)
    } else {
      api.reload('4d36c27f', component.options)
    }
    module.hot.accept("./PatientProfileCriteria.vue?vue&type=template&id=4d36c27f&", function () {
      api.rerender('4d36c27f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PatientProfile/components/common/PatientProfileCriteria.vue"
export default component.exports